import React from 'react';
import { LayoutGrid } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { AddAgeGroupForm } from '../components/AddAgeGroupForm';
import { CoachAssignmentMatrix } from '../components/CoachAssignmentMatrix';
import { useAgeGroupsManagement } from '../hooks/useAgeGroupsManagement';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Skeleton } from '../components/ui/skeleton';

export function AgeGroupsManagement() {
  const {
    ageGroups,
    coaches,
    assignments,
    error,
    loading,
    addAgeGroup,
    updateAgeGroup,
    toggleAssignment,
    startEditing,
    cancelEditing,
    editingGroup,
  } = useAgeGroupsManagement();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="max-w-7xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
        <div className="flex items-center mb-6">
          <LayoutGrid className="w-8 h-8 text-indigo-600 mr-2" />
          <h3 className="text-2xl font-semibold text-gray-900">Age Groups Management</h3>
        </div>

        <Card className="mb-6">
          <CardHeader>
            <CardTitle>Add New Age Group</CardTitle>
          </CardHeader>
          <CardContent>
            <AddAgeGroupForm
              onSubmit={addAgeGroup}
              error={error}
              editingGroup={editingGroup}
              onEditSubmit={updateAgeGroup}
              onCancel={cancelEditing}
            />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Coach Assignments</CardTitle>
          </CardHeader>
          <CardContent>
            {loading ? (
              <div className="space-y-4">
                <Skeleton className="h-12 w-full" />
                <Skeleton className="h-12 w-full" />
                <Skeleton className="h-12 w-full" />
              </div>
            ) : ageGroups.length === 0 ? (
              <p className="text-gray-500 text-center">No age groups found. Add one above.</p>
            ) : (
              <CoachAssignmentMatrix
                ageGroups={ageGroups}
                coaches={coaches}
                assignments={assignments}
                onToggleAssignment={toggleAssignment}
                onEditGroup={startEditing}
              />
            )}
          </CardContent>
        </Card>

        <div className="mt-6">
          <Link to="/administration" className="text-indigo-600 hover:underline">
            ← Back to Dashboard
          </Link>
        </div>
      </main>
    </div>
  );
}